import { ApiService, ApiError } from './api.service'
import { Constants } from '../constants'
import { Location } from './location.service'
import {GroupDropdown} from "@/services/group.service";

class CustomerSettings {
    constructor(location, groups, entity, mode) {
        this.mode = mode // 0 = location spots, 1 = location entities
        this.location = location
        this.entity = entity
        this.groups = groups
        this.dropdownGroups = groups.map(g => new GroupDropdown(g))
        this.locationSpots = location.spots
        this.entities = groups?.flatMap(g => g.entities)
    }
}

class Customer {
    constructor(customer) {
        this.id = customer ? customer.id : undefined
        this.active = customer ? customer.active: false
        this.name = customer ? customer.name : undefined
        this.emailAddress = customer ? customer.emailAddress : undefined
        this.allowSetTimeSlotLength = customer ? customer.allowSetTimeSlotLength : false
        this.locations = customer && customer.locations ? customer.locations.map(o => new Location(o)) : []
        this.locationLabels = this.getLocations()
    }

    getLocations() {
        var locations = []
        for (const location of this.locations) {
            locations.push(location.name)
        }

        return locations.length > 0 ? locations.join(', ') : '-'
    }
}

class CustomerDropdown {
    constructor(customer) {
        this.id = customer.id
        this.value = customer.name
        this.checked = customer.checked || false
    }
}

const CustomerService = {

    getCustomers: async function(showInactive = false) {
        try {
            let query = '?showInactive=' + showInactive
            const response = await ApiService.get(Constants.ENDPOINT_CUSTOMERS+query)
            return response.data
        }catch(error) {
            throw new ApiError(error)
        }
    },

    getCustomer: async function(customerId) {
        try {
            const endpoint = `${Constants.ENDPOINT_CUSTOMERS}/${customerId}`
            const response = await ApiService.get(endpoint)
            return response.data
        }catch(error) {
            throw new ApiError(error)
        }
    },

    createCustomer: async function(customer) {
        try {
            const response = await ApiService.post(Constants.ENDPOINT_CUSTOMERS, customer)
            return response
        }catch(error) {
            throw new ApiError(error)
        }
    },

    updateCustomer: async function(customer) {
        try {
            const endpoint = `${Constants.ENDPOINT_CUSTOMERS}/${customer.id}`
            const response = await ApiService.put(endpoint, customer)
            return response
        }catch(error) {

            throw new ApiError(error)
        }
    }

}

export { CustomerService, Customer, CustomerDropdown, CustomerSettings }
